import React, { useEffect, useState } from "react"
import clsx from "clsx"
import { useRouter } from "next/router"
import queryString from "query-string"

import Helmet from "@lib/helpers/Helmet"
import { PaginationData, SelectOption } from "@interfaces/misc"
import { CategoryMobile, CategoryRow, ClassColumn } from "./components"
import { Header } from "@components/header"
import { container, FlexBox } from "@components/wrapper"
import { ManualSelect } from "@components/select"
import { HariseninFooter } from "@components/harisenin"
import { Category, Course } from "@interfaces/course"
import { AiOutlineSearch } from "react-icons/ai"
import { RegularButton } from "@components/button"
import { useScreenSize } from "@lib/hooks"
// import { useAnalytics } from "@lib/context/AnalyticsContext"

const CLASS_TAG: SelectOption[] = [
  {
    label: "Semua Kelas",
    value: "all",
  },
  {
    label: "Kelas Terpopuler",
    value: "rating",
  },
  {
    label: "Kelas Terbaru",
    value: "new",
  },
]

const CLASS_PRICE: SelectOption[] = [
  {
    label: "Semua",
    value: "all",
  },
  {
    label: "Harga Rendah Tinggi",
    value: "asc",
  },
  {
    label: "Harga Tinggi Ke Rendah",
    value: "dsc",
  },
]

export interface ClassListPageProps {
  categoryList: Category[]
  classList: PaginationData<Course>
  categoryName: string
}

function ClassListPage({ categoryList, categoryName, classList }: ClassListPageProps) {
  const [activeCategory, setActiveCategory] = useState("")
  const [duration, setDuration] = useState("")
  const { screenWidth } = useScreenSize()
  const router = useRouter()
  const query = router.query
  // const { analytics } = useAnalytics()



  // useEffect(() => {
  //   analytics.track("Product List Viewed", {
  //     products: [
  //       {
  //         product_id: "",
  //         name: "",
  //         affiliation: "PT. Karya Kaya Bahagia",
  //         coupon: "",
  //         discount: 0,
  //         currency: "IDR",
  //         brand: "HSL",
  //         category: categoryName,
  //         variant: "",
  //         price: 0,
  //         quantity: 1,
  //         position: 0,
  //         item_list_name: "",
  //         item_list_id: "",
  //       },
  //     ],
  //     item_list_name: "",
  //     item_list_id: "",
  //   })
  // }, [])

  const handleFilter = async (o: unknown, isPrice?: boolean) => {
    const option = o as SelectOption
    const currentQuery = { ...query }
    const categorySlug = currentQuery.slug

    if (currentQuery.slug) {
      delete currentQuery.slug
    }

    if (option.value === "all") {
      delete currentQuery.key
      delete currentQuery.sort
      delete currentQuery.filter
    }

    if (isPrice) {
      currentQuery.key = "price"
      currentQuery.sort = option.value
    } else {
      currentQuery.filter = option.value
    }

    const stringify = queryString.stringify(currentQuery)

    let newRoute = "/category"

    if (categorySlug) {
      newRoute += `/${categorySlug}`
    }

    if (stringify) {
      newRoute += `?${stringify}`
    }

    await router.replace(newRoute)
  }

  const handleSearch = async (data: string) => {
    const newRoute = "/category?search=" + data
    await router.replace(newRoute)
  }

  const handleViewMore = async () => {
    const currentQuery = { ...query }
    const categorySlug = currentQuery.slug
    if (currentQuery.slug) {
      delete currentQuery.slug
    }

    let limit = 9
    if (currentQuery.limit) {
      limit = Number(currentQuery.limit) + 3
    }
    currentQuery.limit = limit.toString()
    const stringify = queryString.stringify(currentQuery)

    let newRoute = "/category"

    if (categorySlug) {
      newRoute += `/${categorySlug}`
    }

    if (stringify) {
      newRoute += `?${stringify}`
    }

    await router.replace(newRoute)
  }

  return (
    <>
      <Helmet title={categoryName ?? "Semua Kelas"} isIndexed />
      <Header />

      <main className="sm:py-[60px] py-10">
        <FlexBox className={clsx(container, "sm:flex-row sm:justify-between", "flex-col")}>
          <div className="sm:mb-[36px] mb-[12px]">
            <h1
              className={clsx("font-urbanist font-semibold sm:text-2xl leading-[36px] mb-3 ", " leading-[24px]")}
            >
              Temukan Apa Yang Menarik Untuk Kamu Pelajari
            </h1>
            <div className="text-grey-97">
              Menampilkan {classList.data.length} kelas favorit yang menarik untuk dipelajari
            </div>
          </div>

          <FlexBox className="gap-2">
            <div className="w-full">
              <div className="flex flex-row border border-grey-ec">
                <input
                  className=" p-2 rounded-r-sm focus:outline-none w-full"
                  placeholder="Cari Kelas"
                  type="text"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const target = e.target as HTMLInputElement
                      handleSearch(target.value)
                    }
                  }}
                />
                <AiOutlineSearch className="my-auto mx-2" size={16} />
              </div>
            </div>
            <div className="h-full">
              <CategoryMobile
                categories={categoryList}
                screenWidth={screenWidth}
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                duration={duration}
                setDuration={setDuration}
              />
            </div>
          </FlexBox>
        </FlexBox>

        <section>
          <FlexBox className={clsx(container, "sm:mt-8 sm:gap-8 mt-4")}>
            <div className={clsx("sm:w-1/3 sm:block", "hidden")}>
              <CategoryRow
                categories={categoryList}
                screenWidth={screenWidth}
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                duration={duration}
                setDuration={setDuration}
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClose={() => {}}
              />
            </div>

            <div className="w-full">
              <section className={clsx("sm:flex sm:justify-end")}>
                <ManualSelect
                  placeholder="Pilih Kelas Berdasarkan"
                  options={CLASS_TAG}
                  className="sm:w-[250px] w-full sm:mb-0 mb-[18px] !outline-none !border-2 !border-grey-ec"
                  onChange={(newValue) => handleFilter(newValue)}
                />

                <ManualSelect
                  placeholder="Urutkan Harga Kelas"
                  options={CLASS_PRICE}
                  className="sm:w-[250px] w-full sm:ml-5"
                  onChange={(newValue) => handleFilter(newValue, true)}
                />
              </section>

              <div className={clsx("sm:mt-8")}>
                <ClassColumn screenWidth={screenWidth} classList={classList} />{" "}
                {classList.last_page > 1 && (
                  <RegularButton
                    className={clsx("mx-auto my:10 sm:w-1/3")}
                    onClick={handleViewMore}
                    customPadding="p-3"
                  >
                    Lihat Lebih Banyak
                  </RegularButton>
                )}
              </div>
            </div>
          </FlexBox>
        </section>
      </main>

      <HariseninFooter />
    </>
  )
}

export default ClassListPage
